import { AfterViewInit, Component, Input, EventEmitter, Output } from '@angular/core';

import { Observable, Subject } from 'rxjs';

import { HasId } from '../../basic-data-management/has-id.interface';

import { MultiSelection } from '../entities/multi-selection.entity';

export type EntitySelection<T> = [T[], boolean];

@Component({
	templateUrl: 'entity-checkbox-list.html'
})
export class EntityCheckboxListComponent<T extends HasId> implements AfterViewInit {
	// Id du champ
	@Input() id!: string;
	
	// Parametres de style
	_mandatory: boolean = false;
	@Input() set mandatory(value: boolean | undefined) {
		if (value) {
			this._mandatory = value;
		}
	}
	get mandatory(): boolean | undefined {
		return this._mandatory;
	}

	_labelClass = 'col-md-1';
	@Input() set labelClass(value: string | undefined) {
		if (value) {
			this._labelClass = value;
		}	
	}
	get labelClass(): string | undefined {
		return this._labelClass;
	}
	
	_fieldClass = 'col-md-3';
	@Input() set fieldClass(value: string | undefined) {
		if (value) {
			this._fieldClass = value;
		}	
	}
	get fieldClass(): string | undefined {
		return this._fieldClass;
	}
	
	// Titre du champ (a fournir par la classe d'implementation)
	label!: string | null;
	
	// Titre de l'option "tous"
	wildcardOptionLabel: string = "Tous";
	
	// Liste des entites a afficher comme options (a fournir par la classe d'implementation) 
	entities: T[] = [];
	
	// Fonction determinant le label d'une entite (a fournir par la classe d'implementation)
	@Input() getEntityColor: (entity: T) => string | null = (_entity: T) => null;
	
	// Fonction determinant le label d'une entite (a fournir par la classe d'implementation)
	getEntityLabel!: (entity: T) => string;
	
	// Fonction determinant le tooltip d'une entite (a fournir par la classe d'implementation, optionnel)
	getEntityTitle: (entity: T) => string | null = (_entity: T) =>  null;
	
	// Fonction determinant quelle(s) entites(s) doivent etre preselectionnes par defaut (a fournir par la classe d'implementation, optionnel)
	shouldBeSelectedByDefaut: (entity: T) => boolean = (_entity: T) => true; 
	
	// Observable indiquant les commandes de reinitialisation du composant
	private initialResetCommands = new Subject<void>();
	_resetCommands: Observable<void> = this.initialResetCommands;
	@Input() set resetCommands(commands: Observable<void> | undefined) {
		if (commands) {
			this._resetCommands = commands;
		} else {
			this._resetCommands = this.initialResetCommands;
		}
	}
	
	// Subject indiquant les requetes de selection provenant du parent (a fournir par la classe d'implementation, optionnel)
	selectionsSubject = new Observable<(entity: T) => boolean>();
	
	// Subject indiquant les requetes de deselection provenant du parent (a fournir par la classe d'implementation, optionnel)
	deselectionsSubject = new Observable<(entity: T) => boolean>();
	
	constructor() {
	}
	
	ngAfterViewInit() {
		// NB: Attention! Comme initialResetCommands est potentiellement bind sur le sous-composant,
		// il faut attendre qu'il ait ete transmis avant d'envoyer le premier signal d'initialisation
		this.initialResetCommands.next();
	}
	
	// Sorties pour le resultat
	@Output() itemDeselected = new EventEmitter<T>();
	@Output() itemSelected = new EventEmitter<T>();
	@Output() selectionIdsChange = new EventEmitter<MultiSelection>();
	@Output() selectionChange = new EventEmitter<EntitySelection<T>>();
	
	onSelectionChange(selection: EntitySelection<T>) {
		const entities = selection[0];
		const allSelected = selection[1]
		const ids = entities.map((entity: T) => entity.id);
		this.selectionIdsChange.emit(new MultiSelection(ids, allSelected));
		this.selectionChange.emit([entities, allSelected]);
	}
}